import { Outlet } from "react-router";
import { useAuth } from "../context/auth";
import { NotFoundPage } from "../pages/NotFoundPage";

export function ValidateWorkspace() {
	const { loading, workspaceStatus } = useAuth();

	if (loading) return null;
	if (workspaceStatus === 404) return <NotFoundPage />;
	return <Outlet />;
}
